/**
 * Exception
 *
 * @author edmsamuel
 */
import React from 'react';
import { message } from 'antd';
import Api from './Api';

export default class Exception {
  /**
   * Constructor
   *
   * @param {Error} e
   */
  constructor(e, message = 'Se encontrarón problemas') {
    this.code = e.response && e.response.status ? e.response : 0

    this.message = (
      e.response ? Api.statusCodeToString(this.code) : message
    )

    if (this.code === 0) {
      this.message = e.message
    }

    this.description = (
      e.response ? (
        typeof e.response.data === 'string' ? e.response.data : e.response.data.message
      ) : this.message
    );

    this.errors = (
      e.errors ? e.errors : [ this.description ]
    );
  }

  /**
   * Error a componente de react
   */
  toComponent() {
    return (
      <div>
        <strong>{this.message}</strong>
        <br />
        {this.errors.length === 1 ? this.errors[0] : this.errors.map((msg, idx) => (
          <span key={idx}>{`- ${msg}`} <br /></span>
        ))}
      </div>
    );
  }

  show() {
    switch (this.code) {
      case 400:
        message.warn(this.toComponent())
        break;

      default:
        message.error(this.toComponent())
        break
    }
  }

  static load(error) {
    return new Exception(error);
  }
}
